import { createReducer } from "../../app/common/util/reducerUtil";
import {
  FETCH_PETTY_CASH_TRANSACTIONS,
  FETCH_UNALLOCATED_TRANSACTIONS,
} from "./pettyCashConstants";

const initialState = {
  transactions: [],
};

export const getPettyCashTransactions = (state, payload) => ({
  ...state,
  transactions: payload.transactions,
});

export const getUnallocatedTransactionsForDashboard = (state, payload) => ({
  ...state,
  unallocated: payload.transactions,
});



export default createReducer(initialState, {
  [FETCH_PETTY_CASH_TRANSACTIONS]: getPettyCashTransactions,
  [FETCH_UNALLOCATED_TRANSACTIONS]: getUnallocatedTransactionsForDashboard,
});
